// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // ✅ Corrected path
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyArErKFNYa1Rk4b0ekE4uN7bUOJRqzOHSI",
  authDomain: "employee-prepxpathshala.firebaseapp.com",
  projectId: "employee-prepxpathshala",
  storageBucket: "employee-prepxpathshala.firebasestorage.app",
  messagingSenderId: "295524352439",
  appId: "1:295524352439:web:db35ded8c020c3471f2832",
  measurementId: "G-JHBCPCBL44"
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "asia-south1");

export default app;